exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner[data-v-ed1003de]{width:100%;background:url(/images/Banner_Background.png);background-position-x:center;background-size:cover;position:relative;top:-32px;border-radius:3px;box-shadow:0 2px 4px 0 rgba(0,0,0,.09);padding:24px 16px;margin:0 auto;color:#fff;font-family:Open Sans,sans-serif;font-size:14px;letter-spacing:.5px;line-height:22px}.banner img[data-v-ed1003de]{position:absolute;left:0;bottom:-24px}", ""]);

// exports
